import React from 'react'
import UpdateDoctorPassword from 'presentation/doctor/pages/UpdatePassword'

export default function makeDoctorUpdatePassword() {
  return <UpdateDoctorPassword />
}
